import { useEffect, useState } from "react";
import { _ConsolidatePAC } from "../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { CardTaps } from "../../../theme/Component/CardTaps";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { SpanRender } from "../../../theme/Component/SpanRender";

interface Props {
    year: number,
    month: number,
    budgetStr: string,
    budgettype: number,
    budgetResource: number,
    budgetSource: number,
}
export const DetailEgress = ({ year, month, budgetStr, budgettype, budgetResource, budgetSource }: Props) => {

    const consolidatePAC = useDataBean(_ConsolidatePAC);
    const { setLista, lista, bean, setBean, instance } = consolidatePAC;
    const [listOB, setListOB] = useState<any>([]);
    const [listCE, setListCE] = useState<any>([]);
    const [listCENP, setListCENP] = useState<any>([]);

    useEffect(() => {
        getLista();
    }, [year, month, budgetStr, budgetResource, budgetSource])

    const getLista = () => {
        instance.getDetalleOBPACRender(year, month, budgetStr, budgettype, budgetResource, budgetSource).then(
            (resp: any) => {
                setListOB(resp);
            }
        )
        instance.getDetalleCEPACRender(year, month, budgetStr, budgettype, budgetResource, budgetSource).then(
            (resp: any) => {
                setListCE(resp);
            }
        )
        instance.getDetalleCEPACRender(year, month, null, null, null, null).then(
            (resp: any) => {
                setListCENP(resp);
            }
        )
    }

    const totalOB = () => {
        let total = 0;
        listOB.forEach(element => {
            total += parseFloat(element.DataBeanProperties.OBValue);
        });
        return total;
    }
    const totalCE = () => {
        let total = 0;
        listCE.forEach(element => {
            total += parseFloat(element.DataBeanProperties.CEValue);
        });
        return total;
    }
    const totalNPCE = () => {
        let total = 0;
        listCENP.forEach(element => {
            total += parseFloat(element.DataBeanProperties.CEValue);
        });
        return total;
    }


    const [indexTap, setIndexTap] = useState(0);
    let taps = [
        { id: 0, name: 'Obligaciones', disable: false },
        { id: 1, name: 'Pagos', disable: false },
        { id: 2, name: 'Pagos NP', disable: false }
    ];
    const headOB = [
        { title: 'Fecha', property: 'OBDocumentDate', visible: true,mask:MASK_DATE },
        { title: 'Nit', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Tercero', property: 'EntityName', visible: true },
        // { title: 'Causación', property: 'UBLIVDocument', visible: true },
        { title: 'Obligación', property: 'OBDocument', visible: true },
        { title: 'Valor', property: 'OBValue', visible: true, mask: MASK_MONEY },
        // {title:'Fecha Causación',property:'DocumentDate',visible:true},
    ]
    const headCE = [
        { title: 'Fecha', property: 'CEDate', visible: true,mask:MASK_DATE },
        { title: 'Nit', property: 'NitAccount', visible: true, mask: MASK_NUMBER },
        { title: 'Tercero', property: 'EntityName', visible: true },
        // { title: 'Obligación', property: 'OBDocument', visible: true },
        { title: 'Causación', property: 'UBLIVDocument', visible: true },
        { title: 'Pago', property: 'CEDocument', visible: true },
        { title: 'Valor', property: 'CEValue', visible: true, mask: MASK_MONEY },
    ]

    return (
        <div className="row">
            <div className="col">
                <CardTaps index={indexTap} updateIndex={setIndexTap} taps={taps}>
                    <div className="row">
                        {indexTap == 0 &&
                            <>
                                <strong><SpanRender value={totalOB()} mask={MASK_MONEY} /></strong>
                                <BasicTable body={listOB} head={headOB} rowSet={setBean}></BasicTable>
                            </>
                        }
                        {indexTap == 1 &&
                            <>
                                <strong><SpanRender value={totalCE()} mask={MASK_MONEY} /></strong>
                                <BasicTable body={listCE} head={headCE} rowSet={setBean}></BasicTable>
                            </>
                        }
                        {indexTap == 2 &&
                            <>
                                <strong><SpanRender value={totalNPCE()} mask={MASK_MONEY} /></strong>
                                <BasicTable body={listCENP} head={headCE} rowSet={setBean}></BasicTable>
                            </>
                        }

                    </div>
                </CardTaps>
            </div>
        </div>
    )
}